// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { withCallDeferredApi } from "@insite/client-framework/Components/DeferredApiContext";
import { withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import Notify from "@keller/App/Components/Notify";
import {
    mapDispatchToPropsForProductList,
    mapStateToPropsForProductList,
    ProductListPage,
    ProductListPageDataContext,
} from "@keller/Overrides/Pages/ProductListPage";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface RecentPurchasedProductsPageStyles {
    title?: TypographyProps;
    page?: MobiusPageProps;
}

const recentPurchasedProductsPageStyles: RecentPurchasedProductsPageStyles = {
    title: {
        variant: "h1",
        css: css`
            margin-bottom: 33px;
        `,
    },
};

const styles = recentPurchasedProductsPageStyles;

class RecentPurchasedProductsPage extends ProductListPage {
    loadProducts() {
        const { displayProducts, search, shellContext } = this.props;
        if (shellContext.isEditing) {
            return;
        }
        displayProducts({
            path: "",
            queryString: search,
            isSearch: false,
            additionalProps: {
                filter: "recentlyPurchased",
            },
        } as any);
    }

    render() {
        if (this.props.shellContext.isEditing) {
            return (
                <Page {...styles.page}>
                    <Notify type="warning">{translate("No products in CMS editing mode")}</Notify>
                </Page>
            );
        }
        if (
            this.props.productsDataView.value?.length &&
            this.props.productsDataView.exactMatch &&
            !this.props.stockedItemsOnly
        ) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        const title = <Typography {...styles.title}>{translate("Recent Purchased Products")}</Typography>;
        return (
            <Page {...styles.page}>
                <CategoryContext.Provider value={this.props.category}>
                    <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                        {title}
                        <Zone contentId={this.props.id} zoneName="Content" />
                        <Modals />
                        <ProductCompareFlyOut />
                    </ProductListPageDataContext.Provider>
                </CategoryContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(
        mapStateToPropsForProductList,
        mapDispatchToPropsForProductList,
    )(withCallDeferredApi(withHistory(withIsInShell(RecentPurchasedProductsPage)))),
    definition: {
        displayName: "Recent Purchased Products",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
